import React, { useState, useEffect, useRef } from 'react';
import { Building2, Heart, Shield, Users, Home, Sparkles, ArrowRight } from 'lucide-react';
import img from '../../assets/renders/coffeespace02.jpeg';
import { Link } from 'react-router-dom';

const Company = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const highlights = [
    { icon: Building2, text: "A sprawling gated community in Thamarasserry" },
    { icon: Home, text: "One bed room and two bed room villa options" },
    { icon: Heart, text: "Full Fledged Wellness Centre" },
    { icon: Users, text: "Club House with well equipped kitchen and entertainment facilities" },
    { icon: Sparkles, text: "Ample Open recreation space" },
    { icon: Shield, text: "Personalized care plans" },
    { icon: Heart, text: "Warm and welcoming community" },
    { icon: Home, text: "Independence and homily living" }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={sectionRef} className="w-full">
      
      {/* Hero Section with Background Image */}
      <div className="pt-12 pb-16 md:pt-20 px-3 sm:px-6 relative overflow-hidden">
        {/* Background Image with Modern Overlay */}
        <div className="absolute inset-0">
          <img 
            src={img}
            alt="Whitespace Properties" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b md:bg-gradient-to-r from-[#ffffff] via-[#ffffff] md:via-[#ffffff]/90 to-white/0"></div>
          <div className="absolute inset-0 bg-gradient-to-b md:bg-gradient-to-t from-[#ffffff]/100 via-[#ffffff]/10 to-transparent"></div>
          <div className="absolute inset-0 bg-gradient-to-t md:bg-gradient-to-b from-[#ffffff]/100 via-[#ffffff]/10 to-transparent"></div>
        </div>
        
        {/* Content */}
        <div className="relative z-10 flex items-center justify-start">
          <div className="max-w-6xl mx-auto w-full">
            <div className="max-w-xl">
              <div className={`inline-flex items-center gap-2 px-4 py-2 backdrop-blur-md rounded-full text-xs font-medium mb-6 border transition-all duration-1000 ease-out ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
                   style={{ 
                     color: 'var(--primarycolor)',
                     borderColor: 'var(--primarycolor)'
                   }}>
                <Building2 size={14} />
                Redefining Senior Living
              </div>
              
              <h1 className={`text-2xl md:text-4xl text-gray-900 mb-6 leading-tight tracking-wide transition-all duration-1000 delay-200 ease-out ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}>
                {/* Redefining Senior Living */}
                <span className="block tracking-tight mt-1" style={{ color: 'var(--primarycolor)' }}>
                  Whitespace Properties LLP
                </span>
              </h1>
              
              <p className={`text-base text-gray-700 mb-8 leading-relaxed transition-all duration-1000 delay-400 ease-out ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}>
                Whitespace Properties LLP is a forward-thinking real estate developer dedicated to redefining senior living in India. 
                With decades of expertise in design, construction, and lifestyle development, we create thoughtfully planned retirement 
                communities that blend comfort, care, and independence. Our mission is to deliver world-class homes that uphold dignity, 
                safety, and wellbeing, ensuring seniors enjoy a vibrant and fulfilling new chapter of life.
              </p>
              
              {/* <div className={`transition-all duration-1000 delay-600 ease-out ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}>
                <Link to='/about'><button className="group inline-flex items-center gap-2 px-6 py-2.5 text-white text-sm font-medium rounded-full transition-all duration-300 bg-[var(--primarycolor)] hover:bg-red-900">
                  Learn More
                  <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
                </button></Link>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Company;